import React, { useState, useEffect } from "react";
import PopupForm from './form';
import axios from 'axios';


const PlanContent = () =>{

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [email, setEmail] = useState();
    const [amount, setAmount] = useState();
    const [errorMessage, setErrorMessage] = useState();
    // const togglePopup = () => {
    //     setIsModalOpen(!isPopupOpen);
    // };

    function selectPlan(amount) {
        setAmount(1)
        setIsModalOpen(true)
    }

    function purchasePlan(){
        // console.log(amount)
        // console.log(email)

        let formData = new FormData();
        formData.append('amount', amount)
        formData.append('email', email)
        formData.append('shopperr', 1)
        
        axios.post("https://api.shopperr.in/pg/planpay" , formData)
            .then(response => {
            
            // let orderId = response.data.orderId;
            if(response.data.error == 1){
                setErrorMessage(response.data.message)
            }else{
                setEmail("")
                setAmount("")
                setErrorMessage("")
                setIsModalOpen(false)
    
                window.open(
                    response.data.redirectUrl,
                    '_blank' // <- This is what makes it open in a new window.
                    );
            }

            
            })
    }

    const closeModal = () => setIsModalOpen(false);
    
    return (
        <>
        <style>
        {`
          .td-border {
            border: 1px solid #e7eef0;
            padding: 18px 40px;
            vertical-align: middle;
          }
        `}
      </style>
        <div className="px-[5%] w-full md:w-full lg:w-[80%] sm:w-full m-auto my-10">
            <h2 className="text-[#06184b] text-lg md:text-xl lg:text-4xl sm:text-lg mb-10 text-center font-bold">Simple and Flexible Pricing</h2>
            <p style={{"fontSize": "16px", "textAlign": "center", "margin": "10px 0 30px 0", "color": "#000"}}>All accounts have access to the forever free Starter Plan.</p>
            <div className="col-lg-12" style={{lineHeight: "1.8"}}>
                <table width="100%" border="1" className="table table-hover table-bordered text-center">
                    <thead>
                        <tr>
                            <td className="td-border" style={{"width":" 25%", "fontWeight": "bold", "color": "#7b999e", "textAlign": "left"}}>Plan name</td>
                            <td className="td-border" style={{"width":" 25%"}}>Starter</td>
                            <td className="td-border" style={{"width":" 25%"}}>Professional</td>
                            <td className="td-border" style={{"width":" 25%"}}>Premium</td>
                        </tr>
                        <tr>
                            <td className="td-border" style={{"width":" 25%", "fontWeight": "bold", "color": "#7b999e", "textAlign": "left"}}>Price</td>
                            <td className="td-border" style={{"width":" 25%"}}>Rs.499<i>/month</i></td>
                            <td className="td-border" style={{"width":" 25%"}}>Rs.1999<i>/month</i></td>
                            <td className="td-border" style={{"width":" 25%"}}>Rs.2999<i>/month</i></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="td-border">Product subscription
                                <span className="pricing-query-value">
                                    <p className="query-explain">Maximum number of subscribed products</p>
                                </span>
                            </td>
                            <td className="td-border">500</td>
                            <td className="td-border">20000</td>
                            <td className="td-border">Unlimited</td>
                        </tr>
                        <tr>
                            <td className="td-border">Orders per month
                                <span className="pricing-query-value">
                                    <p className="query-explain">Maximum number of orders we can fulfill for you every month</p>
                                </span>
                            </td>
                            <td className="td-border">20</td>
                            <td className="td-border">200</td>
                            <td className="td-border">Unlimited</td>
                        </tr>
                        <tr>
                            <td className="td-border">Product information export
                                <span className="pricing-query-value">
                                    <p className="query-explain">Export subscribed product information</p>
                                </span>
                            </td>
                            <td className="td-border"><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                            <td className="td-border"><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                            <td className="td-border"><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                        </tr>
                        <tr>
                            <td className="td-border">Autopay
                                <span className="pricing-query-value">
                                    <i className="fa fa-question-circle-o" aria-hidden="true"></i>
                                    <p className="query-explain">Automatically deduct money from E-wallet balance</p>
                                </span>
                            </td>
                            <td className="td-border"><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                            <td className="td-border"><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                            <td className="td-border"><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                        </tr>
                        <tr>
                            <td className="td-border">Pricing automation
                                <span className="pricing-query-value">
                                    <i className="fa fa-question-circle-o" aria-hidden="true"></i>
                                    <p className="query-explain">Automatically set a percentage product price markup</p>
                                </span>
                            </td>
                            <td className="td-border">&nbsp;</td>
                            <td className="td-border"><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                            <td className="td-border"><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                        </tr>
                        <tr>
                            <td className="td-border">Marketplace API integration
                                <span className="pricing-query-value">
                                    <i className="fa fa-question-circle-o" aria-hidden="true"></i>
                                    <p className="query-explain">Automatically sync inventory, sync price, download orders, update order status, upload tracking numbers, etc.</p>
                                </span>
                            </td>
                            <td className="td-border">&nbsp;</td>
                            <td className="td-border"><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                            <td className="td-border"><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                        </tr>
                        <tr>
                            <td className="td-border">Sales report
                                <span className="pricing-query-value">
                                    <i className="fa fa-question-circle-o" aria-hidden="true"></i>
                                    <p className="query-explain">Comprehensive sales data and analysis</p>
                                </span>
                            </td>
                            <td className="td-border">&nbsp;</td>
                            <td className="td-border">Basic</td>
                            <td className="td-border">Advanced</td>
                        </tr>
                        <tr>
                            <td className="td-border">Product exclusiveness
                                <span className="pricing-query-value">
                                    <i className="fa fa-question-circle-o" aria-hidden="true"></i>
                                    <p className="query-explain">Pick any products to be available for you to resell exclusively. Buyout fee is Rs 2,000 /SKU/month. Please contact Customer Support for details.</p>
                                </span>
                            </td>
                            <td className="td-border">&nbsp;</td>
                            <td className="td-border">&nbsp;</td>
                            <td className="td-border"><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                        </tr>
                        <tr>
                            <td className="td-border">VIP Reward
                                <span className="pricing-query-value">
                                    <i className="fa fa-question-circle-o" aria-hidden="true"></i>
                                    <p className="query-explain">Cashback if you reach certain monthly order volume (case by case). Please contact Customer Support for details.</p>
                                </span>
                            </td>
                            <td className="td-border">&nbsp;</td>
                            <td className="td-border">&nbsp;</td>
                            <td className="td-border"><span className="pricing-feature-value"><i className="fa fa-check-circle" aria-hidden="true" style={{"color": "#19489e"}}></i></span></td>
                        </tr>
                        <tr>
                            <td className="td-border" style={{"fontSize": "20px", "fontWeight":"bold", "color":"#7b999e"}}>Select plan</td>
                            <td className="td-border"><input type="button" className="btn btn-modern" value="Select" onClick={() => selectPlan(499)} style={{"display": "inline-block", "padding": "7px 21px", "color": "#fff", "fontSize": "14px", "textTransform": "capitalize", "borderRadius": "4px", "backgroundColor": "#19489e"}} /></td>
                            <td className="td-border"><input type="button" className="btn btn-modern" value="Select" onClick={() => selectPlan(1999)} style={{"display": "inline-block", "padding": "7px 21px", "color": "#fff", "fontSize": "14px", "textTransform": "capitalize", "borderRadius": "4px", "backgroundColor": "#19489e"}}  /></td>
                            <td className="td-border"><input type="button" className="btn btn-modern" value="Select" onClick={() => selectPlan(2999)} style={{"display": "inline-block", "padding": "7px 21px", "color": "#fff", "fontSize": "14px", "textTransform": "capitalize", "borderRadius": "4px", "backgroundColor": "#19489e"}}  /></td>
                    
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        {isModalOpen && (
            <div 
                className="modal-overlay"
                style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000
                }}
            >
                    <div 
                    className="modal-content relative bg-white p-5 rounded-lg shadow-lg w-96"
                    style={{
                        backgroundColor: "#fff",
                        padding: "20px",
                        borderRadius: "10px",
                        width: "400px",
                        textAlign: "center",
                        boxShadow: "0 5px 10px rgba(0, 0, 0, 0.3)"
                    }}
                    >
                        <button 
                        className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 focus:outline-none" 
                        onClick={closeModal}
                        >
                        ✖
                        </button>
                        
                            <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="fullName">
                            Email
                            </label>
                            <input 
                                id="fullName"
                                type="text" 
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email" 
                                className="w-full border border-gray-300 rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:border-blue-500"
                            />
                            </div>
                            <div><span>{errorMessage}</span></div>
                            <button 
                                className="btn btn-danger bg-[#62c8f5]"
                                onClick={purchasePlan}
                                style={{
                                marginTop: "10px",
                                padding: "10px 20px",
                                fontSize: "16px",
                                cursor: "pointer",
                                color: "#fff",
                                border: "none",
                                borderRadius: "5px"
                                }}
                            >
                                Submit
                            </button>
                        
                    </div>
                
            </div>
        
        ) }
        </>
    );
}

export default PlanContent;